import React from 'react'

import Image from '../../Image';

export default function StepTwo({ hideQaAndDataAnalytics = false }) {
   return (
      <div className='st_eac'>
         <div className='steps_t_2'>Choose your Job Track</div>
         <div className='st_inf_txt'>
            Based on your Fundamentals exam score, we'll also recommend you a
            suitable Job Track.
         </div>
         <div className='st_ops'>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#dbeafe', color: '#1e40af' }}
               >
                  OPTION 1
               </div>
               <div className='st_op_h_tx'>MERN Full Stack</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>6 Months</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                     Fresher Salaries :<br />
                     In India
                  </div>
                  <div className='st_sl_n'>3 LPA - 12 LPA</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>Real-time project</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/mongo-db-logo.png'
                     className='st_e_lim'
                     alt='mongo-db-logo'
                     height={80}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/express-js.png'
                     className='st_e_lim'
                     alt='express-js'
                     height={100}
                     width={104}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/react-js.png'
                     className='st_e_lim'
                     alt='react-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/node-js.png'
                     className='st_e_lim'
                     alt='node-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
               </div>
               <div className='st_ban_con'>
                  <div className='st_se_av_m'></div>
                  <div>Seats Available</div>
               </div>
            </div>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#ffedd5', color: '#9a3412' }}
               >
                  OPTION 2
               </div>
               <div className='st_op_h_tx'>Java Full Stack</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>6 Months</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                     Fresher Salaries :<br />
                     In India
                  </div>
                  <div className='st_sl_n'>3 LPA - 12 LPA</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>Real-time project</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/react-js.png'
                     className='st_e_lim'
                     alt='react-js'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/java.png'
                     className='st_e_lim'
                     alt='java'
                     height={80}
                     width={100}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/spring-boot.png'
                     className='spring'
                     alt='spring-boot'
                     height={100}
                     width={104}
                     loading='lazy'
                  />
               </div>
               <div className='st_ban_con'>
                  <div className='st_se_av_m'></div>
                  <div>Seats Available</div>
               </div>
            </div>
            {!hideQaAndDataAnalytics && (
            <>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#dbeafe', color: '#6b21a8' }}
               >
                  OPTION 3
               </div>
               <div className='st_op_h_tx'>QA/Automation Testing</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>3 Months</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                     Fresher Salaries :<br />
                     In India
                  </div>
                  <div className='st_sl_n'>2 LPA - 7 LPA</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>Real-time project</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/selenium.png'
                     className='selenimu'
                     alt='selenimu'
                     height={80}
                     width={212}
                     loading='lazy'
                  />
               </div>
               <div className='st_ban_conb'>
                  <div className='st_se_av_mb'></div>
                  <div>Seats filled. Next batch starts on 31st Dec 2025</div>
               </div>
            </div>
            <div className='st_op_c'>
               <div
                  className='st_o_ntx'
                  style={{ backgroundColor: '#d1fae5', color: '#065f46' }}
               >
                  OPTION 4
               </div>
               <div className='st_op_h_tx'>Data Analytics</div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/clock.svg'
                     alt='clock'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='dur_txt'>
                     Duration: <span className='st_d_m'>3 Months</span>
                  </div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/salary-note.svg'
                     alt='salary-note'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_sl_t'>
                     Fresher Salaries :<br />
                     In India
                  </div>
                  <div className='st_sl_n'>2 LPA - 7 LPA</div>
               </div>
               <div className='st_t_im_c'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/rocket.svg'
                     alt='rocket'
                     height={18}
                     width={18}
                     loading='lazy'
                  />
                  <div className='st_inf_txt'>Real-time project</div>
               </div>
               <div className='st_ln_co'>
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/powerbi.png'
                     className='st_e_lim'
                     alt='powerbi'
                     height={52}
                     width={53}
                     loading='lazy'
                  />
                  <Image
                     src='https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/tableu.png'
                     className='st_e_lim'
                     alt='tableu'
                     height={100}
                     width={100}
                     loading='lazy'
                  />
               </div>
               <div className='st_ban_conb'>
                  <div className='st_se_av_mb'></div>
                  <div>Seats filled. Next batch starts on 31st Dec 2025</div>
               </div>
            </div>
            </>
            )}
         </div>
      </div>
   )
}
